/* SCENT & SILK · Premium-Ebene (v3.1) */
(() => {
  // Kaufleiste auf dem Handy: erscheint, sobald der Haupt-Kaufbutton aus dem Bild scrollt
  const bar = document.querySelector('[data-ssp-sticky]');
  const mainButton = document.querySelector('.ss-product-form button[name="add"]');
  if (bar && mainButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach((b) => (b.tabIndex = show ? 0 : -1));
    });
    observer.observe(mainButton);
  }

  // Handy-Menü schliessen, wenn ein Link darin angetippt wird oder Escape gedrückt wird
  const menu = document.querySelector('.ss-mobile-menu');
  if (menu) {
    menu.addEventListener('click', (event) => {
      if (event.target.closest('.sv-mobile-nav a, .sv-mobile-nav button')) menu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });
    menu.addEventListener('toggle', () => {
      menu.querySelector('summary')?.setAttribute('aria-label', menu.open ? 'Menü schliessen' : 'Menü öffnen');
    });
  }
})();
